import NiceModal from '@ebay/nice-modal-react';
import { createAction } from 'redux-actions';

import { RESULTS_LIMIT } from 'constants/general';
import MODALS from 'constants/modals';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import documents from 'features/views/production/documents';
import { PRODUCED_PRODUCTION_FILTER_FORM_NAME } from 'features/views/production/documents/form';
import user from 'features/views/user';
import { trimFormData } from 'utils';

import * as types from './actionTypes';
import { dialogs } from './constants';
import { documentsBodyFactory, documentsQueryParamsFactory } from './utils';

export const setDocuments = createAction(types.SET_DOCUMENTS, (documents) => ({ documents }));
export const reset = createAction(types.RESET);
export const productionReported = createAction(types.PRODUCTION_REPORTED);

export const loadDocuments =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const data = await getFormData(PRODUCED_PRODUCTION_FILTER_FORM_NAME);
		const formData = trimFormData(data);
		const userRole = user.selectors.getCurrentRole(getState());

		dispatch(
			fetch.actions.post(fetch.constants.urls.productionDocuments, {
				takeLatest: true,
				uniqueReqID: 'reported',
				body: documentsBodyFactory(formData, userRole),
				queryParams: documentsQueryParamsFactory(),
				onSuccess: [
					(response) => () => {
						const data = response.body.data;
						const totalRows = response.body.pageMetaData.totalRows;

						if (!data || !Array.isArray(data)) return;

						if (totalRows && totalRows > RESULTS_LIMIT) {
							return dispatch(dialog.actions.open(dialogs.documentRecordsLimit));
						}

						dispatch(setDocuments(data));
					},
				],
			}),
		);
	};

export const closeProduction =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const data = await getFormData(PRODUCED_PRODUCTION_FILTER_FORM_NAME);
		const formData = trimFormData(data);
		const userRole = user.selectors.getCurrentRole(getState());

		dispatch(productionReported());
		dispatch(
			fetch.actions.post(fetch.constants.urls.productionClose, {
				body: documents.utils.requestBodyFactory(formData, userRole),
				onSuccess: [
					() => () => {
						dispatch(documents.actions.reload());
						NiceModal.hide(MODALS.producedProduction_report);
					},
				],
			}),
		);
	};
